import { useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { silenceAbort } from "lib/error";
import { useAPIClient } from "render/context/APIContext";
import { FLAGS, Flags } from "lib/flags";

interface Options {
  signal?: AbortSignal;
}

const Sibyllegatan = "SE-ARN12";

function queryFn(apiClient: APIClient, { signal }: Options) {
  const req = apiClient.site.querySites();
  req.result.catch(silenceAbort);
  signal?.addEventListener("abort", req.abandon);
  return req.result
    .then(({ items }) => items)
    .then((sites) => {
      if (FLAGS.has(Flags.MultiSite)) {
        return sites;
      }
      return sites.filter(
        (site) =>
          site.siteId.toLocaleLowerCase() !== Sibyllegatan.toLocaleLowerCase()
      );
    });
}

function queryKey() {
  return ["sites"];
}

export function useSitesQuery() {
  const apiClient = useAPIClient();
  return useQuery({
    queryKey: queryKey(),
    queryFn: ({ signal }) => queryFn(apiClient, { signal }),
  });
}
